import React from "react";
import { Row, Col } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import FaqImage from "../images/FaqImage2.webp";
import { defaultFaqs } from "../seo/faqData";

const FaqHome = () => {
  return (
    <div>
      <div className="container">
        <h2 style={{ fontFamily: "sans-serif" }}>Frequently Asked Questions</h2>
        <div>
          <Row>
            <Col className="mt-4">
              <Accordion defaultActiveKey={["0"]} alwaysOpen flush>
                {defaultFaqs.map((faq, index) => (
                  <Accordion.Item eventKey={`${index}`} key={faq.question}>
                    <Accordion.Header>
                      <h6 style={{ fontFamily: "Lato, sans-serif" }}>
                        {faq.question}
                      </h6>
                    </Accordion.Header>
                    <Accordion.Body style={{ fontFamily: "Lato, sans-serif" }}>
                      {faq.answer}
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </Col>
            <Col className="FaqImage">
              <img
                src={FaqImage}
                alt="Frequently asked questions"
                style={{ width: "100%", height: "95%", marginBottom: "20px" }}
              />
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};

export default FaqHome;
